var render = function () {
  var _vm$board2, _vm$board2$files$;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "title": "커뮤니티",
            "src": "/images/sub/subvisual-community.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('page-section', {
    staticClass: "page-section--first page-section--last",
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_vm._v("IR")];
      },
      proxy: true
    }])
  }, [_c('table', {
    staticClass: "board-view"
  }, [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.board.subject))])]), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('v-row', {
    staticClass: "row--sm"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', [_vm._v("작성일 : " + _vm._s(_vm.$dayjs(_vm.board.createdAt).format("YYYY-MM-DD HH:mm:ss")))])])], 1)], 1)]), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('v-row', {
    staticClass: "row--sm"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "pr-6px pr-md-10px"
  }, [_c('icon-down', {
    staticClass: "primary--text"
  })], 1), _c('span', {
    on: {
      "click": function click($event) {
        var _vm$board, _vm$board$files$;

        return _vm.download((_vm$board = _vm.board) === null || _vm$board === void 0 ? void 0 : (_vm$board$files$ = _vm$board.files[0]) === null || _vm$board$files$ === void 0 ? void 0 : _vm$board$files$.url);
      }
    }
  }, [_vm._v("첨부파일 : " + _vm._s((_vm$board2 = _vm.board) === null || _vm$board2 === void 0 ? void 0 : (_vm$board2$files$ = _vm$board2.files[0]) === null || _vm$board2$files$ === void 0 ? void 0 : _vm$board2$files$.fileName))])])])], 1)], 1)]), _c('tr'), _c('tr', [_c('td', {
    staticClass: "content_box",
    attrs: {
      "colspan": "2"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.board.content)
    }
  })])])]), _c('div', {
    staticClass: "pt-16px pt-md-24px"
  }, [_c('v-row', {
    staticClass: "row--xs",
    attrs: {
      "justify": "end"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticStyle: {
      "border-radius": "10px 0 10px 0"
    },
    attrs: {
      "tile": "",
      "outlined": "",
      "color": "grey"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.go(-1);
      }
    }
  }, [_vm._v("리스트")])], 1)], 1)], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }